/*
 * Class providing custom dimension-color rule for specific product. Rule is checking chosen options and returning true or false.
 * {ralLimit} - we assume that colors with RAL number higher than 7001 are dark (except colors marked as white)
 * {widthLimit} - width limit for product
 * {heightLimit} - height limit for product
 * {productId} - product ID eligible for rule
 */
class CustomDimensionColorRuleService {
    constructor() {
        this.ralLimit = 7001;
        this.widthLimit = 4862;
        this.heightLimit = 2600;
        this.productIdLimit = 37;
    }

    checkProductLimitation(productId, width, height, color) {
        this.productId = productId;
        this.width = width;
        this.height = height;
        this.color = color;

        return this.areDimensionsOverLimit() &&
            this.isColorDark() &&
            this.isThisProductWithinLimitation();
    }

    hideColorOnDimensionOverLimit(productId, width, height, colorOption) {
        this.productId = productId;
        this.width = width;
        this.height = height;

        return this.areDimensionsOverLimit() &&
            this.isThisProductWithinLimitation() &&
            !colorOption.attributes.isWhite &&
            +colorOption.attributes.ral > this.ralLimit;
    }

    areDimensionsOverLimit() {
        return this.width >= this.widthLimit && this.height >= this.heightLimit;
    }

    isColorDark() {
        return !this.color.attributes.isWhite &&
            +this.color.attributes.ral > this.ralLimit;
    }

    isThisProductWithinLimitation() {
        return this.productId === this.productIdLimit;
    }
}

export default angular.module('customDimensionColorRuleService', [])
    .service('customDimensionColorRuleService', CustomDimensionColorRuleService)
    .name;
